(function ($) {
    $(function () {
        var flexCarousel = $('.small-banner');

        if (flexCarousel.length < 1) {
            return;
        }

        var smallBanner = tns({
            container: '.small-carousel',
            items: 1,
            autoplay: false,
            controls: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 5000,
            speed: 2000,
            loop: true,
            nav: false,
            mouseDrag: false,
            arrowKeys: false,
            touch: true,
            preventActionWhenRunning: true,
            gutter: 0,
            responsive: {
                1140: {
                    items: 4,
                },
                960: {
                    items: 3,
                },
                720: {
                    items: 2,
                }
            }
        });
    });
})(jQuery);